import {ChangeDetectionStrategy, Component, computed, inject} from "@angular/core"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {BrushSettingsPanelComponent} from "@app/textures/texture-editor/operator-stack/operators/shared/panel/brush-settings-panel/brush-settings-panel.component"
import {BrushSettings} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/brush-strokes/definition"
import {ButtonComponent} from "@common/components/buttons/button/button.component"
import {ToggleComponent} from "@common/components/buttons/toggle/toggle.component"
import {SliderComponent} from "@common/components/inputs/slider/slider.component"
import {LayerEditMode, LayerMoveMode} from "@app/textures/texture-editor/operator-stack/operators/layer-and-mask/operator-layer-and-mask-types"
import type {OperatorLayerAndMask} from "@app/textures/texture-editor/operator-stack/operators/layer-and-mask/operator-layer-and-mask"
import {ViewMode} from "@app/textures/texture-editor/operator-stack/operators/tiling/toolbox/tiling-area/spatial-mapping-item"
import {PermissionsService} from "@common/services/permissions/permissions.service"
import {OperatorPanelBase} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator-panel-base"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-layer-and-mask-panel",
    templateUrl: "./layer-and-mask-panel.component.html",
    styleUrls: ["./layer-and-mask-panel.component.scss"],
    imports: [InspectorSectionComponent, ToggleComponent, SliderComponent, ButtonComponent, BrushSettingsPanelComponent],
})
export class LayerAndMaskPanelComponent extends OperatorPanelBase<OperatorLayerAndMask> {
    protected readonly permission = inject(PermissionsService)
    $can = this.permission.$to

    readonly $layerMinOpacity = computed(() => this.$operator().$layerMinOpacity())

    protected setLayerMinOpacity(value: number) {
        this.$operator().setLayerMinOpacity(value)
    }

    readonly $layerMaxOpacity = computed(() => this.$operator().$layerMaxOpacity())

    protected setLayerMaxOpacity(value: number) {
        this.$operator().setLayerMaxOpacity(value)
    }

    readonly $maskFeathering = computed(() => this.$operator().$maskFeathering())

    protected setMaskFeathering(value: number) {
        this.$operator().setMaskFeathering(value)
    }

    readonly $layerEditMode = computed(() => this.$operator().$layerEditMode())

    protected setLayerEditMode(value: LayerEditMode) {
        this.$operator().setLayerEditMode(value)
    }

    readonly $layerMoveMode = computed(() => this.$operator().$layerMoveMode())

    protected setLayerMoveMode(value: LayerMoveMode) {
        this.$operator().setLayerMoveMode(value)
    }

    readonly $brushSettings = computed(() => this.$operator().$brushSettings())

    protected setBrushSettings(value: BrushSettings) {
        this.$operator().setBrushSettings(value)
    }

    readonly $showGuides = computed(() => this.$operator().$showGuides())

    protected setShowGuides(value: boolean) {
        this.$operator().setShowGuides(value)
    }

    readonly $showMask = computed(() => this.$operator().$showMask())

    protected setShowMask(value: boolean) {
        this.$operator().setShowMask(value)
    }

    layerEditModes = LayerEditMode
    layerMoveModes = LayerMoveMode
    protected readonly ViewMode = ViewMode
}
